import {Component, OnInit} from '@angular/core';
import {Startup} from '../../../model/startup';
import {Router} from '@angular/router';
import {StartupService} from '../../../service/startup.service';
import {BaseComponent} from '../../../base/base.component';
import {TranslateService} from '@ngx-translate/core';
import {Enum} from '../../../model/common_model';

@Component({
  selector: 'app-step-two',
  templateUrl: './step-two.component.html',
  styleUrls: ['./step-two.component.scss']
})
export class StepTwoComponent extends BaseComponent implements OnInit {

  modelStep: Enum = new Enum();
  model: Startup = new Startup();
  stepIndex = 1;

  constructor(public router: Router,
              public translate: TranslateService,
              public startUpService: StartupService) {
    super(router, translate);
  }

  ngOnInit(): void {
    this.startUpService.updateStartUpStepSource(this.modelStep);
    this.startUpService.startUp.subscribe({
      next: data => {
        this.model = data as Startup;
      }, error: err => super.onError(err)
    });
  }

  actionNextStep() {
    const arrValidateFields = [
      {value: this.model.startupName, text: (this.translate.instant('comun.nomestartup') + '*,<br>')},
      {value: this.model.site, text: 'Site*,<br>'},
      {value: this.model.linkedin, text: 'Linkedin*,<br>'}
    ];

    const stringError = this.validateField(arrValidateFields);

    if (!super.isNullOrUndefined(stringError)) {
      this.showMessage(this.translate.instant('comun.atencao'), `${this.translate.instant('comun.campos')}: <br><br> ${stringError}`);
      return;
    }

    this.startUpService.updateStartUpDataSource(this.model);

    this.nextStep(this.stepIndex);
  }

}
